// extracted by mini-css-extract-plugin
export default {"status_container":"Providers_status_container__5GkC4","status":"Providers_status__XsZKC","providers_list":"Providers_providers_list__nTKS7"};